import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { HistoryAPI } from "services/history";
import {
  getHistory,
  getHistorySuccess,
  getHistoryFailure,
  changeSubscriptionInfo,
  changeSubscriptionInfoSuccess,
  changeSubscriptionInfoFailure,
  resendEmail,
  resendEmailSuccess,
  resendEmailFailure,
  cancelTransaction,
  cancelTransactionSuccess,
  cancelTransactionFailure,
} from "redux/reducers/history-structure-note";
import { toPagingServer } from "utils/common-util";
import { HistorySelector } from "redux/selector/history-selector";
import { message } from "antd";

function* getStructureNoteHistorySaga({ payload }) {
  try {
    const { isLoadMore, startDateFrom, startDateTo, extend } = payload;
    const paginable = yield select(HistorySelector.StructureNote.paginable);
    const nextPage = isLoadMore ? { ...paginable, current: paginable.current + 1 } : paginable;
    const params = {
      ...toPagingServer(nextPage),
      startDateFrom,
      startDateTo,
    };
    const response = yield call(HistoryAPI.StructureNote.getHistory, params);
    let histories = response.data.result.histories,
      total = response.data.result.total;
    histories.forEach((history) => {
      history.expandRef = `expanded-row-${history.substId}`; // for Desktop
      history.substIdDisplay = history.substId?.replace(/(\d{1})(\d{2})(\d{6})/, "$1-$2-$3");
    });
    if (extend) {
      const fetchedHistories = yield select(HistorySelector.StructureNote.histories);
      histories = [...fetchedHistories, ...histories];
    }
    yield put(getHistorySuccess({ histories, total, paginable: nextPage }));
  } catch (error) {
    console.error(error);
    yield put(getHistoryFailure(error));
  } finally {
    if (payload.unblockLoadMore) payload.unblockLoadMore();
  }
}

function* changeStructureNoteReceiveMethodSaga({ payload }) {
  try {
    yield call(HistoryAPI.StructureNote.editSubscriptionInfo, payload);
    message.info(payload.successMessage);
    yield put(changeSubscriptionInfoSuccess(payload));
  } catch (error) {
    yield put(changeSubscriptionInfoFailure(error));
  }
}

function* resendEmailSaga({ payload }) {
  try {
    yield call(HistoryAPI.StructureNote.resendEmail, payload);
    message.info("ส่งอีเมลเรียบร้อย");
    yield put(resendEmailSuccess(payload));
  } catch (error) {
    yield put(resendEmailFailure(error));
  }
}

function* cancelTransactionSaga({ payload }) {
  try {
    yield call(HistoryAPI.StructureNote.cancelTransaction, payload);
    message.info("ส่งคำร้องขอยกเลิกรายการเรียบร้อย");
    yield put(cancelTransactionSuccess(payload));
  } catch (error) {
    yield put(cancelTransactionFailure(error));
  }
}

const saga = [
  takeLeading(getHistory.type, getStructureNoteHistorySaga),
  takeLatest(changeSubscriptionInfo.type, changeStructureNoteReceiveMethodSaga),
  takeLatest(resendEmail.type, resendEmailSaga),
  takeLatest(cancelTransaction.type, cancelTransactionSaga),
];

export default saga;
